<div id="layout-wrapper">
  <app-topbar-new *ngIf="isDashboard"></app-topbar-new>
  <app-topbar *ngIf="!isDashboard"></app-topbar>
  <!-- <app-sidebar></app-sidebar> -->
  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="">
    <div [ngClass]="isDashboard ? 'page-content-dashboard' : 'page-content-mobile'">
      <router-outlet></router-outlet>
    </div>
    <app-footer-mobile *ngIf="mobileFooterFlag" (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()"></app-footer-mobile>
  </div>
  <app-rightsidebar></app-rightsidebar>
</div>
<!-- END layout-wrapper -->
